// extracted by mini-css-extract-plugin
export default {"terms":"Terms_terms__1Rs8F","back":"Terms_back__qSZ3V"};